module.exports = __webpack_public_path__ + "img/toplogo.64818c77.svg";